import {
    FETCH_TAGS_REQUEST,
    GET_TAGS,
    GET_SINGLE_TAG,
    TAGS_ERROR,
    SET_CLICKED_TAG,
} from '../ActionTypes';

const initialState = {
    tags: [],
    singleTag: [],
    clickedTag: '',
    newTag: '',
    loading: true,
    error: '',
};

const tagReduction = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TAGS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_TAGS:
            return {
                ...state,
                tags: action.payload,
                loading: false,
                error: '',
            };
        case GET_SINGLE_TAG:
            return {
                ...state,
                singleTag: action.payload,
                loading: false,
                error: '',
            };
        case SET_CLICKED_TAG:
            return {
                ...state,
                clickedTag: action.payload,
                loading: false,
                error: '',
            };
        case TAGS_ERROR:
            return {
                ...state,
                tags: [],
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default tagReduction;
